import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { ADUser } from '../model/ADUser'
import { NotificationService } from "../../common/component/notification/notification.service";

@Injectable()
export class ADService {

    constructor(private http: HttpClient, private notificationService: NotificationService) {

    }

    searchUsers(searchHint: string): Observable<ADUser[]> {
        return this.http.get<ADUser[]>(environment.apiBaseUrl + `ad/users?searchHint=${searchHint}`)
            .pipe(catchError(this.handleError<ADUser[]>('searchUsers')))
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            this.notificationService.alert("error", "Error while saving", error);
            return of(result as T);
        }

    }

}
